export default "__VITE_ASSET__C$BzNP0P__"